<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap1"><a id="start">Part One</a></h1><a id="start">
<h1 class="center">Summer – Fall 1937</h1>
<p class="center" style="margin-top:20px;"><i>I sent a message to the fish:</i></p>
<p class="center"><i>I told them, “This is what I wish.”</i></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0-chap1.vue?567290df